import { memo } from 'react';
import { Skeleton } from '@/components/ui/skeleton';

export const LessonViewerPageSkeleton = memo(function LessonViewerPageSkeleton() {
  return (
    <div className="flex flex-col h-full bg-background">
      {/* Top bar skeleton */}
      <div className="h-12 w-full border-b border-border/20 flex items-center justify-between px-4">
        <div className="flex items-center gap-3">
          <Skeleton className="h-8 w-8 rounded-md" />
          <Skeleton className="h-4 w-32 rounded-md" />
          <Skeleton className="h-4 w-4 rounded-md" />
          <Skeleton className="h-4 w-24 rounded-md" />
          <Skeleton className="h-4 w-4 rounded-md" />
          <Skeleton className="h-4 w-28 rounded-md" />
        </div>
        <div className="flex items-center gap-1.5">
          {[0, 1, 2, 3, 4].map((i) => (
            <Skeleton key={i} className="w-2 h-2 rounded-full" />
          ))}
        </div>
      </div>

      {/* Two-panel layout */}
      <div className="flex flex-1 overflow-hidden">
        {/* Left panel — AI chat (35%) */}
        <div className="w-[35%] border-r border-border/20 flex flex-col">
          <div className="px-4 py-3 border-b border-border/20">
            <Skeleton className="h-5 w-20 rounded-md" />
          </div>
          <div className="flex-1 p-3 space-y-3">
            {/* Chat bubble skeletons */}
            <div className="flex justify-start">
              <Skeleton className="h-12 w-[70%] rounded-lg" />
            </div>
            <div className="flex justify-end">
              <Skeleton className="h-8 w-[50%] rounded-lg" />
            </div>
            <div className="flex justify-start">
              <Skeleton className="h-16 w-[75%] rounded-lg" />
            </div>
          </div>
          <div className="p-3 border-t border-border/20">
            <div className="flex gap-2">
              <Skeleton className="h-10 flex-1 rounded-md" />
              <Skeleton className="h-10 w-10 rounded-md" />
            </div>
          </div>
        </div>

        {/* Right panel — content (65%) */}
        <div className="flex-1 p-6 space-y-6">
          <Skeleton className="w-full aspect-video rounded-lg" />
          <div className="space-y-3">
            <Skeleton className="h-4 w-full rounded-md" />
            <Skeleton className="h-4 w-[90%] rounded-md" />
            <Skeleton className="h-4 w-[80%] rounded-md" />
            <Skeleton className="h-4 w-[85%] rounded-md" />
          </div>
        </div>
      </div>
    </div>
  );
});
